import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
export const createBackgroundColorPropsSDKFactory = buildColorPropsSDKFactoryCreator('backgroundColor');
//# sourceMappingURL=backgroundColorPropsSDKFactory.js.map